export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8628.82e09771.jpg";